import {ButtonParams} from "../../../../../../../core/types/button-params.types";
import {BannerSocialFileActionButton} from "../types/banners-social-modal.types";

export const bannersSocialHeaderButtons: Array<ButtonParams<BannerSocialFileActionButton>> = [
  {
    key: 'showFileLibrary',
    icon: 'apps',
    tooltipText: 'Сменить режим просмотра',
  },
  {
    key: 'history',
    icon: 'info',
    tooltipText: 'История изменений'
  },
  {
    key: 'upload',
    icon: 'upload',
    tooltipText: 'Загрузить файл(ы)'
  },
  {
    key: 'download',
    icon: 'download',
    tooltipText: 'Скачать архив'
  }
]
